// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js_chunk." + chunkId + "." + {"6004":"87a8f1ca5218554ccd29","6131":"e1fe68393cade3f4a7de","6524":"9d2a1b967d1a52527b63","7206":"53d1e51c05601e59422c","8962":"1d046675d96df63efd77"}[chunkId] + ".min.js";
};